import React from 'react';
import { createSvgIcon } from '../utils/createSvgIcon';

export const ArrowDown = createSvgIcon(
  () => (
    <path d="M36.9008 17.0346C36.009 16.1427 34.6712 16.2319 33.7793 17.0346L23.5229 27.8261L23.5229 2.14047C23.5229 0.981048 22.631 -9.65841e-07 21.3824 -9.11263e-07L18.5285 -7.86513e-07C17.369 -7.35833e-07 16.388 0.981048 16.388 2.14047L16.388 27.8261L6.22077 17.0346C5.32891 16.2319 3.99112 16.1427 3.09926 17.0346L1.13716 18.9967C0.334486 19.7993 0.334487 21.2263 1.13716 22.029L18.5285 39.3311C19.3311 40.223 20.6689 40.223 21.4716 39.3311L38.8629 22.029C39.6656 21.2263 39.6656 19.8885 38.8629 18.9967L36.9008 17.0346Z" />
  ),
  '0 0 40 40'
);
